import { React, useEffect, useState } from 'react';
import { Grommet, Card, CardHeader, Heading, Header, Anchor, CardBody, CardFooter, Box, Text, Button, Image, Tab, Tabs } from 'grommet';
import { hpe } from 'grommet-theme-hpe';


const LicenseAgreementComponent = ({ }) => {
    const basePath = window.location.origin;
    const pathName = window.location.pathname;
    let licensefilePath = `${basePath}${pathName}assets/LicenseAgreements.json`;
    const [LicenseLinks, setLinksData] = useState(null);
    console.log('LicenseLinks', LicenseLinks);
    debugger
    useEffect(() => {
        const fetchLicenseData = async () => {
            try {
                const response = await fetch(licensefilePath, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }); // Ensure this path points to the public directory
                if (!response.ok) {
                    throw new Error(`Network response was not ok from License Agreement: ${response.statusText}`);
                }

                const json = await response.json(); // Read and parse the response body as JSON
                console.log('Parsed License JSON data:', json); // Log parsed JSON to verify structure

                const data = json.links;
                setLinksData(data);

            } catch (error) {
                console.error('Error fetching or parsing the License Agreement JSON file:', error); // Log fetching and parsing errors

            } finally {

            }
        };

        fetchLicenseData();
    }, []);



    return (

        <Grommet themeMode="light" theme={hpe}>
            <Box overflow-y="hidden" fill align="start" justify="start" pad="small" gap="small">
                <Card
                    overflow-y="hidden"
                    background="light-1"
                    round="small"
                    elevation="medium"
                    pad="medium"
                    //pad={{ left: 'medium', vertical: 'small', right: 'medium' }}
                >


                    <Header  >
                        <Heading weight="bold" level={3}>
                            License Agreements
                        </Heading>
                    </Header>
                    <CardBody overflow-y="hidden"  >
                        <Box align="start" gap="small" pad="small" >
                            <Text>
                                By downloading these products, you agree to the terms and conditions of the End User License Agreement(s) listed below.
                            </Text>
                            <Text>
                                Refer to the documentation regarding using the image once downloaded to your environment.
                            </Text>
                        </Box>

                        <Box align="start" gap="medium" pad="medium" margin={{ top: "small" }}>
                            {LicenseLinks && LicenseLinks.length > 0 ? (
                                <Box align="start" gap="medium" pad="medium">
                                    {LicenseLinks.map((link, index) => (
                                        <Box key={index} gap="small">
                                            <Anchor
                                                href={link.url}
                                                label={link.name}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            ) : (
                                <Text>No License Links available</Text>
                            )}
                        </Box>
                    </CardBody>
                </Card>
            </Box>
        </Grommet>
    );
};


export default LicenseAgreementComponent;
